import { Configuration } from "@azure/msal-browser";

const { REACT_APP_AZURE_AD_CLIENT_ID,REACT_APP_AZURE_AD_AUTHORITY,REACT_APP_LOCAL_URL } = process.env

export const msalConfig: Configuration = {
  auth: {
    clientId: REACT_APP_AZURE_AD_CLIENT_ID!,//"fac72e00-0032-4ccc-a8c3-4a1f136f560b",
    authority: REACT_APP_AZURE_AD_AUTHORITY!,//"https://login.microsoftonline.com/5db8bf0e-8592-4ed0-82b2-a6d4d77933d4",
    redirectUri: REACT_APP_LOCAL_URL!,//"https://cars.ispacezone.com"
    //"http://localhost:3000",
    // "https://cars.ispacezone.com",//
  },
  cache: {
    cacheLocation: "localStorage", // "sessionStorage" ก็ได้
    storeAuthStateInCookie: false, // แนะนำสำหรับ modern browser
  },
};
